<template>
  <component
    :is="transition.type"
    v-bind="transition.data"
    :background="transition.background && transition.background.fields.file.url"
    @next="validate"
  />
</template>

<script>
import { mapGetters } from 'vuex'

import { REGISTER_COMPLETION } from '@/store/modules/completion/types'
import { VvButton } from '@/components/common'
import TransitionComponents from '@/components/transition'

export default {
  name: 'TastingTransition',
  components: { VvButton, ...TransitionComponents },
  computed: {
    ...mapGetters({
      transition: 'currentTastingTransition',
      section: 'currentSection',
      firebaseId: 'tastingFirebaseId'
    })
  },
  methods: {
    validate() {
      this.$store.dispatch(REGISTER_COMPLETION, {
        contentType: 'tasting',
        id: this.transition.id,
        status: {
          complete: true
        }
      })

      this.$emit('next')
    }
  }
}
</script>
